import React from 'react';
import styled from 'styled-components';
import DropDownItemWrapper from './DropDownItemWrapper';
import DropDownItemName from './DropDownItemName';

export interface SelectDropDownItemProps {
  checked: boolean;
  name: string;
  onChange: VoidFunction;
}

const Input = styled.input`
  margin-right: 10px;
`;

const SelectDropDownItemWrapper = styled(DropDownItemWrapper)`
  :hover {
    cursor: pointer;
  }
`;

const SelectDropDownItem: React.FC<SelectDropDownItemProps> = ({
  checked,
  name,
  onChange,
}): JSX.Element => {
  return (
    <SelectDropDownItemWrapper onClick={() => (!checked ? onChange() : null)}>
      <Input type="radio" checked={checked} onChange={() => {}} />
      <DropDownItemName>{name}</DropDownItemName>
    </SelectDropDownItemWrapper>
  );
};

export default SelectDropDownItem;
